import React, { FC } from 'react';
import { Grid, Button, IconButton, Typography } from '@material-ui/core';
import SVGTwitterIcon from '@assets/SVGTwitterIcon';
import SVGLinkedinIcon from '@assets/SVGLinkedinIcon';
import SVGEmailIcon from '@assets/SVGEmailIcon';
import SVGFbIcon from '@assets/SVGFbIcon';
import {
  redirectToSendspark,
  shareLinkOnFacebook,
  shareLinkOnLinkedIn,
  shareLinkOnMail,
  shareLinkOnTwitter,
} from '@utils/segmentHelpers';
import useStyles from './styles';
import { EnvConfig } from '@pages/video-script-generator';

interface IRightSideProps { env: EnvConfig }

const RightSide: FC<IRightSideProps> = ({ env }) => {
  const classes = useStyles();
  return (
    <>
      <Typography component="h5" className={classes.title}>
        Start recording with Sendspark! 🎥✨
      </Typography>
      <Typography component="p" className={classes.paragraph}>
        Sendspark is the #1 video platform for sales communication. Create your
        free account to record and share your video today!
      </Typography>

      <Button
        variant="contained"
        color="primary"
        className={classes.sendsparkButton}
        onClick={() => redirectToSendspark(true, env)}
      >
        Get Sendspark Free!
      </Button>

      <Typography component="h5" className={classes.title}>
        What is Sendspark?
      </Typography>
      <Typography component="p" className={classes.paragraph}>
        Sendspark gives you superpowers for sales. You can use Sendspark to
        record 1x1 videos for prospects, create dynamic videos to share at
        scale, and more! Learn more at sendspark.com.
      </Typography>

      <Typography component="h5" className={classes.title}>
        Meet our partners 😎
      </Typography>
      <Typography component="span" className={classes.paragraph}>
        Now that you have your video script, try these products to start connecting!
        {' '}
        <a
          className={classes.link}
          href="https://hyperwriteai.com/?utm_source=sendspark"
          target="_blank"
          rel="noreferrer"
        >
          HyperWrite&apos;s
        </a>
        {' '}
        AI tools can help you break through writer&apos;s block and create amazing content in seconds.
        {' '}
        <a
          className={classes.link}
          href="https://reply.io/?gspk=YmV0aGFueXN0YWNoZW5mZWxkMjM3OQ&gsxid=BFK0i8XXAz7N"
          target="_blank"
          rel="noreferrer"
        >
          Reply
        </a>
        {' '}
        lets you automate emails & follow up messages.
        {' '}
        <a
          className={classes.link}
          href="https://go.expandi.io/sendspark"
          target="_blank"
          rel="noreferrer"
        >
          Expandi
        </a>
        {' '}
        can help you scale across LinkedIn.
        And
        {' '}
        <a
          className={classes.link}
          href="https://try.zoominfo.com/74wv0ffpfz0x"
          target="_blank"
          rel="noreferrer"
        >
          ZoomInfo
        </a>
        {' '}
        can help you find contact information, so you know where to send your videos. We&apos;re all rooting for your success!
      </Typography>

      <Typography component="h5" className={classes.title}>
        If this was helpful, please share it!
      </Typography>
      <Typography component="p" className={classes.paragraph}>
        Show others how they can easily generate a video script for sales!
      </Typography>
      <Grid container className={classes.socialButtonsContainer}>
        <IconButton
          className={classes.socialButton}
          onClick={() => shareLinkOnTwitter(env)}
        >
          <SVGTwitterIcon />
        </IconButton>
        <IconButton
          className={classes.socialButton}
          onClick={() => shareLinkOnLinkedIn(env)}
        >
          <SVGLinkedinIcon />
        </IconButton>
        <IconButton className={classes.socialButton} onClick={() => shareLinkOnMail(env)}>
          <SVGEmailIcon />
        </IconButton>
        <IconButton
          className={classes.socialButton}
          onClick={() => shareLinkOnFacebook(env)}
        >
          <SVGFbIcon />
        </IconButton>
      </Grid>
    </>
  );
};

export default RightSide;
